// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Leaflet Custom Styles for AirExportInsights */
.leaflet-container {
  font-family: system-ui, -apple-system, sans-serif;
}

/* Make countries with data stand out with subtle glow */
.leaflet-interactive.country-with-data {
  filter: drop-shadow(0 0 1px rgba(6, 95, 70, 0.3));
}

/* Country dot markers with pulse animation */
.country-dot-marker {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  pointer-events: auto !important;
}

.country-dot-marker img {
  display: none !important;
}

.custom-tooltip {
  background: white !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  padding: 0 !important;
}

.custom-tooltip .leaflet-popup-content-wrapper {
  background: white;
  border-radius: 8px;
}

.custom-tooltip .leaflet-popup-tip {
  display: none;
}

.leaflet-control-attribution {
  font-size: 10px !important;
  background: rgba(255, 255, 255, 0.8) !important;
}

/* Country Labels - crisp and clean */
.country-label {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  pointer-events: none !important;
}

.country-label-text {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  pointer-events: none !important;
  filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.9));
}

.country-label-text-empty {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  pointer-events: none !important;
  opacity: 0.7 !important;
}

.country-label div {
  pointer-events: none !important;
  margin: 0;
  padding: 0;
  line-height: 1.2;
  font-weight: 900 !important;
  font-size: 16px !important;
}

.country-label-text div {
  pointer-events: none !important;
  margin: 0;
  padding: 0;
  line-height: 1.2;
  font-weight: 800 !important;
  font-size: 13px !important;
}

.country-label-text-empty div {
  pointer-events: none !important;
  margin: 0;
  padding: 0;
  line-height: 1.2;
  font-weight: 600 !important;
  color: #9ca3af !important;
}

/* Ensure proper z-index for labels */
.leaflet-marker-pane {
  z-index: 600;
}

.country-label img {
  display: none !important;
}

.country-label-text img {
  display: none !important;
}

.country-label-text-empty img {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/AirExportInsights.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,iDAAiD;AACnD;;AAEA,wDAAwD;AACxD;EACE,iDAAiD;AACnD;;AAEA,6CAA6C;AAC7C;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,wDAAwD;EACxD,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,qDAAqD;AACvD;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["/* Leaflet Custom Styles for AirExportInsights */\n.leaflet-container {\n  font-family: system-ui, -apple-system, sans-serif;\n}\n\n/* Make countries with data stand out with subtle glow */\n.leaflet-interactive.country-with-data {\n  filter: drop-shadow(0 0 1px rgba(6, 95, 70, 0.3));\n}\n\n/* Country dot markers with pulse animation */\n.country-dot-marker {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  pointer-events: auto !important;\n}\n\n.country-dot-marker img {\n  display: none !important;\n}\n\n.custom-tooltip {\n  background: white !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;\n  padding: 0 !important;\n}\n\n.custom-tooltip .leaflet-popup-content-wrapper {\n  background: white;\n  border-radius: 8px;\n}\n\n.custom-tooltip .leaflet-popup-tip {\n  display: none;\n}\n\n.leaflet-control-attribution {\n  font-size: 10px !important;\n  background: rgba(255, 255, 255, 0.8) !important;\n}\n\n/* Country Labels - crisp and clean */\n.country-label {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  pointer-events: none !important;\n}\n\n.country-label-text {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  pointer-events: none !important;\n  filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.9));\n}\n\n.country-label-text-empty {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  pointer-events: none !important;\n  opacity: 0.7 !important;\n}\n\n.country-label div {\n  pointer-events: none !important;\n  margin: 0;\n  padding: 0;\n  line-height: 1.2;\n  font-weight: 900 !important;\n  font-size: 16px !important;\n}\n\n.country-label-text div {\n  pointer-events: none !important;\n  margin: 0;\n  padding: 0;\n  line-height: 1.2;\n  font-weight: 800 !important;\n  font-size: 13px !important;\n}\n\n.country-label-text-empty div {\n  pointer-events: none !important;\n  margin: 0;\n  padding: 0;\n  line-height: 1.2;\n  font-weight: 600 !important;\n  color: #9ca3af !important;\n}\n\n/* Ensure proper z-index for labels */\n.leaflet-marker-pane {\n  z-index: 600;\n}\n\n.country-label img {\n  display: none !important;\n}\n\n.country-label-text img {\n  display: none !important;\n}\n\n.country-label-text-empty img {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
